import styled, { css } from 'styled-components'

export interface TooltipPanelContainerProps {
  $active?: boolean
}

export const Container = styled.div.withConfig({
  shouldForwardProp: (prop) => !prop.startsWith('$'),
})<TooltipPanelContainerProps>`
  position: absolute;
  top: 0;
  right: 0;
  width: 320px;
  height: 100%;
  background: ${({ theme }) => theme.colors.background.primary};
  box-shadow: -2px 0 8px rgba(0, 0, 0, 0.1);
  transform: translateX(100%);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 60;
  display: flex;
  flex-direction: column;

  ${({ $active }) =>
    $active &&
    css`
      transform: translateX(0);
    `}

  @media (max-width: 768px) {
    position: fixed;
    /* top: 64px; */
    right: 0;
    width: 100%;
    max-width: 100%;
    height: calc(100vh - 56px);
    transform: translateX(100%);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
`

export const TooltipHeader = styled.div`
  padding: 16px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border.default};
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const TooltipTitle = styled.h3`
  font-size: 15px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0;
`

export const TooltipClose = styled.button`
  width: 26px;
  height: 26px;
  border: none;
  background: transparent;
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.secondary};
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    background: ${({ theme }) => theme.colors.background.tertiary};
    color: ${({ theme }) => theme.colors.text.primary};
  }

  .icon {
    width: 13px;
    height: 13px;
    stroke: currentColor;
    stroke-width: 2;
    fill: none;
  }

  /* Mobile: Ensure 44px minimum touch target */
  @media (max-width: 768px) {
    width: ${({ theme }) => theme.touchTargets.minimum};
    height: ${({ theme }) => theme.touchTargets.minimum};
  }

  /* Disable hover effects on touch devices */
  @media (hover: none) {
    &:hover {
      background: transparent;
      color: ${({ theme }) => theme.colors.text.secondary};
    }

    &:active {
      background: ${({ theme }) => theme.colors.background.tertiary};
      color: ${({ theme }) => theme.colors.text.primary};
    }
  }
`

export const TooltipContent = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 16px;
`
